import { render, staticRenderFns } from "./SchoolFaculty.vue?vue&type=template&id=e6bfb040&scoped=true&"
import script from "./SchoolFaculty.vue?vue&type=script&lang=js&"
export * from "./SchoolFaculty.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFaculty.vue?vue&type=style&index=0&id=e6bfb040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bfb040",
  null
  
)

export default component.exports